import React from 'react'
import styles from './styles'

const Body = ({ children }) => <main className={styles.wrapper}>{children}</main>

export default Body
